/**
 * 请求认证拦截器
 */
import { getToken } from '../../../handler/token.storage'

const authInterceptor = conf => {
  getToken() && (conf.headers['Authorization'] = getToken())
  return conf
}

export default authInterceptor
